import { CampaignReward } from "@brandclub/common-ui";
import { graphqlFetch } from "./graphqlFetch";

export interface BrandClubForBrandPublic {
  brandclubId?: string;
  companyId?: string;
  divisionId?: string;
  imageUrl?: string;
  name?: string;
  brandIds?: number[];
  brandId?: number;
  searchScore?: number;
  totalRewardAmount?: number;
  hasRewards?: boolean;
  campaignRewards?: CampaignReward[];
  availableSurveyRewardAmount?: number;
  availableContentRewardAmount?: number;
}

export const GET_BRAND_CLUB_FOR_BRAND_PUBLIC = `
  query getBrandClubForBrandPublic($brandId: Float!) {
    BrandClubForBrandPublic(brandId: $brandId) {
      brandclubId
      companyId
      divisionId
      imageUrl
      name
      brandIds
      brandId
      searchScore
      totalRewardAmount
      hasRewards
      campaignRewards
      availableSurveyRewardAmount
      availableContentRewardAmount
    }
  }
`;

export const getBrandClubForBrandPublic = async (
  brandId: number,
  signal?: AbortSignal
): Promise<BrandClubForBrandPublic | undefined> => {
  const { data } = await graphqlFetch({
    operationName: "getBrandClubForBrandPublic",
    query: GET_BRAND_CLUB_FOR_BRAND_PUBLIC,
    variables: { brandId },
    signal,
  });
  return data?.BrandClubForBrandPublic;
};
